import { render, staticRenderFns } from "./assetInventory.vue?vue&type=template&id=2c0bff98&scoped=true"
import script from "./assetInventory.vue?vue&type=script&lang=js"
export * from "./assetInventory.vue?vue&type=script&lang=js"
import style0 from "./assetInventory.vue?vue&type=style&index=0&id=2c0bff98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bff98",
  null
  
)

export default component.exports